import './phone-input.scss'
import 'react-phone-input-2/lib/style.css'

import {Box, Label} from 'exsportia-components'
import {useFormikContext} from 'formik'
import {FC} from 'react'
import PhoneInputBase from 'react-phone-input-2'

export type PhoneInputProps = {
  countryCode?: string
  label?: string
  id: string
  disabled?: boolean
  value?: string
  onChange?: (value: string) => void
}

export const PhoneInput: FC<PhoneInputProps> = ({
  countryCode = 'gb',
  label,
  id,
  disabled,
  value: externalValue,
  onChange: externalOnChange,
}) => {
  const formik = useFormikContext<any>()
  const values = formik?.values || {}
  const errors = formik?.errors || {}
  const setFieldValue = formik?.setFieldValue

  const rawValue = externalValue ?? values[id]
  let value = rawValue
  if (typeof rawValue === 'string') {
    const clean = rawValue.replace(/[^\d+]/g, '')
    value = clean.startsWith('+') || !clean ? clean : `+${clean}`
  }

  const error = errors[id] as string

  const onChangeToUse = (val: string) => {
    if (disabled) {
      return
    }
    if (externalOnChange) {
      externalOnChange(val)
    } else if (setFieldValue) {
      (async () => await setFieldValue(id, val ? `+${val}` : null))()
    }
  }

  return (
    <>
      {label && (
        <Label
          settings={{
            color: error ? 'error' : 'text-secondary',
          }}
        >
          {label}
        </Label>
      )}
      <PhoneInputBase
        key={countryCode}
        inputClass='phone-input'
        containerClass='phone-input-container'
        buttonClass='phone-input-button'
        dropdownClass='phone-input-dropdown'
        country={countryCode.toLowerCase()}
        specialLabel=''
        onChange={onChangeToUse}
        value={value}
        inputStyle={{
          borderColor: error ? '#ED0A34' : 'rgba(237, 49, 99, 0.14)',
        }}
        disabled={disabled}
      />
      {error && (
        <Box
          mt='5px'
          mb='10px'
          fontSize='12px'
          color='error'
        >
          {error}
        </Box>
      )}
    </>
  )
}
